import classNames from 'classnames';
import React from 'react';
import alertIcon from '../../icons/non-prefilled/16x16/alert.svg';
import SVGIcon from '../SVGIcon';
import Tooltip from '../Tooltip';
import * as styles from './TextareaControl.module.scss';

export interface TextareaControlProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  label?: React.ReactNode;
}

const TextareaControl = ({
  error,
  label,
  ...inputProps
}: TextareaControlProps) => (
  <label>
    {!!label && <div className={styles.label}>{label}</div>}
    <div
      className={classNames(styles.textAreaContainer, {
        [styles.error]: error,
      })}
    >
      <textarea className={styles.input} {...inputProps} />
      {error && (
        <div className={styles.errorContainer}>
          <Tooltip
            display="block"
            content={error}
            danger
            offset={14}
            enabledForSmallSize
            trigger="clickOrHover"
          >
            <SVGIcon className={styles.errorIcon}>{alertIcon}</SVGIcon>
          </Tooltip>
        </div>
      )}
    </div>
  </label>
);

export default TextareaControl;
